import React from "react";
import { View, StyleSheet } from "react-native";
import { Image } from "expo-image";
import { LinearGradient } from "expo-linear-gradient";

interface DefaultAvatarProps {
  colors: [string, string];
  imageUrl: string;
  size: number;
}

/**
 * Renders a default avatar: gradient background
 * with an instrument SVG centered on top.
 */
const DefaultAvatar = ({ colors, imageUrl, size }: DefaultAvatarProps) => {
  const instrumentSize = size * 0.55;

  return (
    <View style={[styles.container, { width: size, height: size }]}>
      <LinearGradient
        colors={[colors[0], colors[1]]}
        start={{ x: 0, y: 0 }}
        end={{ x: 1, y: 0 }}
        style={StyleSheet.absoluteFill}
      />
      <Image
        source={{ uri: imageUrl }}
        style={{ width: instrumentSize, height: instrumentSize }}
        contentFit="contain"
      />
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    alignItems: "center",
    justifyContent: "center",
    overflow: "hidden",
  },
});

export default DefaultAvatar;
